import Modal from "@mui/material/Modal";
import { makeStyles } from "@material-ui/core/styles";

/**
 * @param {React Component} children Anything that could be used in between opening and closing tags
 * @param {Object} config The acceptable config params for the modal base
 *      @param {boolean} open
 *          => if true it displays the modal
 *          => if false the modal won't be displayed
 *      @param {function} handleClose the function that will be called when the modal is closed
 * 
 * @returns {React Component} A modal containing the children received as an argument
 */

const BaseModal = ({ children, config: { open, handleClose } }) => {
    const classes = useStyles(open);

    return (
        <Modal className={classes.root} open={open} onClose={handleClose}>
            <div className={classes.modalWrapper}>{children}</div>
        </Modal>
    );
};

export default BaseModal;

const useStyles = makeStyles((theme, open) => ({
    root: {
        "&> *": {
            boxSizing: "border-box",
            fontFamily: theme.fontFamily,
        },
    },
    modalWrapper: {
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        opacity: open ? 0 : 1,
        transition: 'all 0.3s ease-in-out',
        minWidth: "400px",
        position: "absolute",
        backgroundColor: "white",
        borderRadius: "4px",
        boxShadow: theme.shadows[5],
        outline: "none",
    }
}));
